import { render, staticRenderFns } from "./partnerEdit.vue?vue&type=template&id=08b503c4&"
import script from "./partnerEdit.vue?vue&type=script&lang=js&"
export * from "./partnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports